export const POSITION_SLUG = "position";
export const PROGRAM_CARD_SLUG = "program-card";
export const GEO_SLUG = "geos";
